import React from 'react';

import FlatButton from 'material-ui/FlatButton';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import * as validator from 'helpers/Validator';
import { AccentColor } from 'helpers/AccentColorHelper';

import MultiSelectExtended from 'components/shared/MultiSelectExtended';
import ReferralLink from './ReferralLink';

class ReferralDialog extends React.Component {
  UNSAFE_componentWillMount() {
    this.setState({ open: false, loading: false, propertyId: null });
  }

  createReferralLink = ev => {
    const propertyId = ev.value;

    this.setState({ loading: true, propertyId });
    this.props.createReferralLink(propertyId).then(() => {
      this.setState({ loading: false });
    });
  };

  handleSubmit = () => {};

  toggleOpen = () => {
    if (this.props.toggleOpen) {
      this.props.toggleOpen();
    }

    this.setState({ open: !this.state.open });
  };

  render() {
    // Use as a props.open override of internal state
    const isOpen = this.props.open !== undefined ? this.props.open : this.state.open;
    const referralLink = this.props.referralLinks[this.state.propertyId] || '';

    return (
      <Dialog
        disableBackdropClick
        fullScreen={this.props.fullScreen}
        open={isOpen}
        onClose={this.toggleOpen}
        classes={{ paper: 'form-dialog' }}
        onExit={() => this.setState({ propertyId: null })}
        aria-labelledby="refer-a-friend"
      >
        <DialogTitle id="refer-a-friend">
          <h3 style={{ textAlign: 'center', margin: 0 }}>Refer a Friend to Apply</h3>
        </DialogTitle>

        <DialogContent>
          <div className="row" style={{ padding: '0 15px' }}>
            <p>
              Invite a friend to apply to rent with your current property manager. Select a property
              and we&apos;ll create an application link you can share or email to a friend.
            </p>
          </div>

          <div className="row" style={{ marginBottom: '10px', padding: '0 15px' }}>
            <div className="col-sm-12" style={{ marginTop: '23px' }}>
              <MultiSelectExtended
                name="property"
                hintText="Property"
                data={this.props.properties}
                onChange={this.createReferralLink}
                fullWidth
                validate={[validator.multi_select_required]}
              />
            </div>
          </div>

          <div className="row" style={{ padding: '0 15px' }}>
            <ReferralLink referralLink={referralLink} loading={this.state.loading} />
          </div>
        </DialogContent>

        <DialogActions style={{ display: 'block' }}>
          <FlatButton onClick={this.toggleOpen} id="close-button" style={{ color: AccentColor() }}>
            CANCEL
          </FlatButton>
        </DialogActions>
      </Dialog>
    );
  }
}

export default withMobileDialog()(ReferralDialog);
